var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"isPro3"},[_c('div',{staticClass:"centerBox"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.desc))]),_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.img}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }